export const PAGINATION_LIMIT = 200;

export const getPaginationLimit = (limit: number) => Math.min(limit, PAGINATION_LIMIT);
